
import UserService from '@/services/user.service';
import LyraService from '@/services/lyra.service';
import * as custom_hooks from "@/assets/js/hooks.js";

/**
 * @classdesc Le panier d'un ajout d'option à une commande
 * @kind class
 * @export
 * @class Ammend_Commande_Option_Cart
 */
export default class Ammend_Commande_Option_Cart {
    id_commande;
    uuid_commande;
    id_amended_commande;
    prix = 0;
    prix_total = 0;
    taxe = 0;
    nb_articles = 0;
    options = [];
    activites = [];
    articles = [];
    alertes_sms = [];
    plans_entrainement = [];
    envois_postal = [];
    logs = [];
    /**
     * Creates an instance of Ammend_Commande_Option_Cart.
     * @constructs
     * @kind function
     * @memberof Ammend_Commande_Option_Cart
     */
    constructor() { }



    update(list_commandes_inscriptions_coureur) {

        this.options = [];
        this.activites = [];
        this.articles = [];
        this.alertes_sms = [];
        this.plans_entrainement = [];
        this.envois_postal = [];
        this.logs = [];
        this.prix = 0;
        this.prix_total = 0;
        this.taxe = 0;
        this.nb_articles = 0;
        for (let i = 0; i < list_commandes_inscriptions_coureur.length; i++) {
            for (let j = 0; j < list_commandes_inscriptions_coureur[i].list_options_amended.length; j++) {
                let option = list_commandes_inscriptions_coureur[i].list_options_amended[j];
                if (parseInt(option.quantite_souhaite) > 0) {
                    this.nb_articles += parseInt(option.quantite_souhaite);
                    option.beneficiaire = list_commandes_inscriptions_coureur[i].inscriptions[0].nom + " " + list_commandes_inscriptions_coureur[i].inscriptions[0].prenom;
                    option.id_commande_inscription = list_commandes_inscriptions_coureur[i].id;
                    option.id_inscription = list_commandes_inscriptions_coureur[i].inscriptions[0].id;

                    this.options.push(option);
                    this.prix += parseFloat(option.prix) * parseInt(option.quantite_souhaite);
                    this.logs.push("Achat de " + option.quantite_souhaite + "x " + option.nom + " pour " + option.prix + "€/unité pour " +
                        list_commandes_inscriptions_coureur[i].inscriptions[0].nom + " " + list_commandes_inscriptions_coureur[i].inscriptions[0].prenom);
                }
            }
            for (let k = 0; k < list_commandes_inscriptions_coureur[i].list_activites_amended.length; k++) {
                let activite = list_commandes_inscriptions_coureur[i].list_activites_amended[k];
                if (parseInt(activite.quantite_souhaite) > 0) {
                    this.nb_articles += parseInt(activite.quantite_souhaite);
                    activite.beneficiaire = list_commandes_inscriptions_coureur[i].inscriptions[0].nom + " " + list_commandes_inscriptions_coureur[i].inscriptions[0].prenom;
                    activite.id_commande_inscription = list_commandes_inscriptions_coureur[i].id;
                    activite.id_inscription = list_commandes_inscriptions_coureur[i].inscriptions[0].id;

                    this.activites.push(activite);
                    this.prix += parseFloat(activite.prix) * parseInt(activite.quantite_souhaite);
                    this.logs.push("Achat de " + activite.quantite_souhaite + "x " + activite.nom + " pour " + activite.prix + "€/unité pour " +
                        list_commandes_inscriptions_coureur[i].inscriptions[0].nom + " " + list_commandes_inscriptions_coureur[i].inscriptions[0].prenom);
                }
            }
            for (let l = 0; l < list_commandes_inscriptions_coureur[i].list_articles_amended.length; l++) {

                let article = list_commandes_inscriptions_coureur[i].list_articles_amended[l];
                if (parseInt(article.quantite_souhaite) > 0) {
                    this.nb_articles += parseInt(article.quantite_souhaite);
                    article.beneficiaire = list_commandes_inscriptions_coureur[i].inscriptions[0].nom + " " + list_commandes_inscriptions_coureur[i].inscriptions[0].prenom;
                    article.id_commande_inscription = list_commandes_inscriptions_coureur[i].id;
                    article.id_inscription = list_commandes_inscriptions_coureur[i].inscriptions[0].id;

                    this.articles.push(article);
                    this.prix += parseFloat(article.prix) * parseInt(article.quantite_souhaite);
                    this.logs.push("Achat de " + article.quantite_souhaite + "x " + article.nom + " pour " + article.prix + "€/unité pour " +
                        list_commandes_inscriptions_coureur[i].inscriptions[0].nom + " " + list_commandes_inscriptions_coureur[i].inscriptions[0].prenom);
                }
            }

            // Gérer l'alerte SMS
            if (list_commandes_inscriptions_coureur[i].alerte_sms_amended && list_commandes_inscriptions_coureur[i].alerte_sms_amended.selected) {
                this.nb_articles += 1;
                let alerte_sms = { ...list_commandes_inscriptions_coureur[i].alerte_sms_amended };
                alerte_sms.beneficiaire = list_commandes_inscriptions_coureur[i].inscriptions[0].nom + " " + list_commandes_inscriptions_coureur[i].inscriptions[0].prenom;
                alerte_sms.id_coureur = list_commandes_inscriptions_coureur[i].inscriptions[0].id_coureur;
                alerte_sms.id_commande_inscription = list_commandes_inscriptions_coureur[i].id;
                alerte_sms.id_inscription = list_commandes_inscriptions_coureur[i].inscriptions[0].id;
                this.alertes_sms.push(alerte_sms);
                this.prix += parseFloat(alerte_sms.prix);
                this.logs.push("Achat de l'alerte SMS pour " + alerte_sms.prix + "€ pour " +
                    list_commandes_inscriptions_coureur[i].inscriptions[0].nom + " " + list_commandes_inscriptions_coureur[i].inscriptions[0].prenom);
            }

            if (list_commandes_inscriptions_coureur[i].plan_entrainement_amended && list_commandes_inscriptions_coureur[i].plan_entrainement_amended.selected) {
                this.nb_articles += 1;
                let plan_entrainement = { ...list_commandes_inscriptions_coureur[i].plan_entrainement_amended };
                plan_entrainement.beneficiaire = list_commandes_inscriptions_coureur[i].inscriptions[0].nom + " " + list_commandes_inscriptions_coureur[i].inscriptions[0].prenom;
                plan_entrainement.id_coureur = list_commandes_inscriptions_coureur[i].inscriptions[0].id_coureur;
                plan_entrainement.id_commande_inscription = list_commandes_inscriptions_coureur[i].id;
                plan_entrainement.id_inscription = list_commandes_inscriptions_coureur[i].inscriptions[0].id;
                this.plans_entrainement.push(plan_entrainement);
                this.prix += parseFloat(plan_entrainement.prix);
                this.logs.push("Achat du " + (plan_entrainement.titre || "plan d'entraînement") + " pour " + plan_entrainement.prix + "€ pour " +
                    list_commandes_inscriptions_coureur[i].inscriptions[0].nom + " " + list_commandes_inscriptions_coureur[i].inscriptions[0].prenom);
            }

            if (list_commandes_inscriptions_coureur[i].envoi_postal_amended && list_commandes_inscriptions_coureur[i].envoi_postal_amended.selected
                && list_commandes_inscriptions_coureur[i].envoi_postal_amended.isValid()) {
                this.nb_articles += 1;
                let envoi_postal = { ...list_commandes_inscriptions_coureur[i].envoi_postal_amended };
                envoi_postal.beneficiaire = list_commandes_inscriptions_coureur[i].inscriptions[0].nom + " " + list_commandes_inscriptions_coureur[i].inscriptions[0].prenom;
                envoi_postal.id_coureur = list_commandes_inscriptions_coureur[i].inscriptions[0].id_coureur;
                envoi_postal.id_commande_inscription = list_commandes_inscriptions_coureur[i].id;
                envoi_postal.id_inscription = list_commandes_inscriptions_coureur[i].inscriptions[0].id;
                this.envois_postal.push(envoi_postal);
                this.prix += parseFloat(envoi_postal.prix);
                this.logs.push("Achat de l'envoi postal du dossard pour " + envoi_postal.prix + "€ pour " +
                    list_commandes_inscriptions_coureur[i].inscriptions[0].nom + " " + list_commandes_inscriptions_coureur[i].inscriptions[0].prenom);
            }
        }
        this.taxe = this.compute_taxe();
        this.prix_total = this.prix + this.taxe;
    }

    async post() {
        let res = await UserService.postAmendCommande(this);
        if (res) {
            this.id_amended_commande = res.id;
            return await true;
        }
        return await false;
    }

    async set_paid_free_checkout() {
        try {
            await LyraService.setPaidFreeCheckoutAmendOptions(this.id_amended_commande);
            return true;
        } catch (error) {
            return false;
        }
    }

    compute_taxe() {

        if (this.id_module && this.id_module == 63) {
            return custom_hooks.compute_tax_TSV24(this.prix);
        }
        if (this.id_module && this.id_module == 229) {
            return custom_hooks.compute_tax_TSV25(this.prix);
        }
        if (this.id_module && this.id_module == 402) {
            return custom_hooks.compute_tax_TSV26(this.prix);
        }
        if (this.id_module && this.id_module == 541) {
            return custom_hooks.compute_tax_ASSR26(this.prix);
        }

        if (this.id_module && this.id_module == 68) {
            return custom_hooks.compute_tax_CAPVAR24(this.prix);
        }
        if (this.id_module && this.id_module == 418) {
            return custom_hooks.compute_tax_XCOAIX(this.prix);
        }
        if (this.id_module && this.id_module == 233) {
            return custom_hooks.compute_tax_CAPVAR25(this.prix);
        }

        if (this.id_module && this.id_module == 177) {
            return custom_hooks.compute_tax_VTTCAV24(this.prix);
        }
        if (this.id_module && this.id_module == 85) {
            return custom_hooks.compute_tax_TMB24(this.prix);
        }
        if (this.id_module && this.id_module == 250) {
            return custom_hooks.compute_tax_CVRIB25(this.prix);
        }
        if (this.id_module && this.id_module == 337) {
            return custom_hooks.compute_tax_MAXIRACE26(this.prix);
        }

        if (this.id_module && this.id_module == 458) {
            return custom_hooks.compute_tax_RUNFEST26(this.prix);
        }
        if (this.id_module && this.id_module == 538) {
            return custom_hooks.compute_tax_BACKYARD_ESPOIR_2026(this.prix);
        }


        // Si le prix est à 0, la taxe est de 0
        if (this.prix == 0) return 0;
        // Si le prix est inférieur à 9, la taxe est de 0,5
        if (this.prix < 9) {
            return 0.5;
        }
        // Si le prix est compris entre 9 et 100, la taxe est de 7% ou 1,2€, ce qu'il y a de plus élevé
        if (this.prix >= 9 && this.prix < 100) {
            let taxe = (this.prix * 7) / 100;
            taxe = Math.max(1.2, taxe);
            taxe = taxe.toFixed(2);
            return parseFloat(taxe);
        }
        // Si le prix est compris entre 100 et 200, la taxe est de 6%
        if (this.prix >= 100 && this.prix < 200) {
            let taxe = (this.prix * 6) / 100;
            taxe = taxe.toFixed(2);
            return parseFloat(taxe);
        }
        // Si le prix est supérieur ou égal à 200, la taxe est de 5%
        if (this.prix >= 200) {
            let taxe = (this.prix * 5) / 100;
            taxe = taxe.toFixed(2);
            return parseFloat(taxe);
        }
    }
}